/* ============================================================
   artvision® · Künstlerprofil · Biografie kürzen
   Der Text steht vollständig im Markup und wird erst hier
   begrenzt — ohne JavaScript bleibt er lesbar. Der Umschalter
   erscheint nur, wenn wirklich etwas abgeschnitten ist.

   Aufgeklappt wächst die Sektion nicht: die Textspalte behält
   die Höhe des gekürzten Zustands und scrollt in sich, damit das
   Atelierbild daneben seine Größe behält. Weiche Kanten oben und
   unten zeigen an, in welche Richtung es weitergeht — die
   Bildlaufleiste allein ist auf macOS unsichtbar, solange man
   nicht scrollt.
   Auf schmalen Bildschirmen entfällt das Scrollen: eine
   Scrollfläche in der Seite ist dort schwer zu bedienen.
   ============================================================ */
(function () {
  var FADE = 40;
  var MOBILE = 749;

  function init(body) {
    var toggle = body.parentNode.querySelector('[data-av-clamp-toggle]');
    if (!toggle) return;

    /* Basisklasse kommt aus dem Markup: ein leeres data-av-clamp
       meint die Kuenstlerbiografie, andere Sektionen nennen ihre
       eigene Klasse.                                              */
    var base = body.getAttribute('data-av-clamp') || 'av-ar-about__body';
    var CLAMPED = base + '--clamped';
    var SCROLL = base + '--scroll';
    /* "grow": aufgeklappt waechst der Abschnitt mit, statt in sich
       zu scrollen. Nur dort sinnvoll, wo daneben kein Bild in der
       Hoehe haengt.                                               */
    var grows = body.getAttribute('data-av-clamp-mode') === 'grow';

    var more = toggle.getAttribute('data-label-more') || 'Mehr anzeigen';
    var less = toggle.getAttribute('data-label-less') || 'Weniger anzeigen';
    var open = false;

    function fade() {
      if (!body.classList.contains(SCROLL)) return;
      var rest = body.scrollHeight - body.scrollTop - body.clientHeight;
      body.style.setProperty('--av-fade-top', (body.scrollTop > 4 ? FADE : 0) + 'px');
      body.style.setProperty('--av-fade-bottom', (rest > 4 ? FADE : 0) + 'px');
    }

    function collapse() {
      open = false;
      body.classList.remove(SCROLL);
      body.style.maxHeight = '';
      body.style.removeProperty('--av-fade-top');
      body.style.removeProperty('--av-fade-bottom');
      body.classList.add(CLAMPED);
      body.scrollTop = 0;
      toggle.textContent = more;
      toggle.setAttribute('aria-expanded', 'false');
    }

    function expand() {
      open = true;
      if (!grows && window.innerWidth > MOBILE) {
        body.style.maxHeight = body.clientHeight + 'px';
        body.classList.add(SCROLL);
      }
      body.classList.remove(CLAMPED);
      toggle.textContent = less;
      toggle.setAttribute('aria-expanded', 'true');
      fade();
    }

    function measure() {
      if (open) return;
      body.classList.add(CLAMPED);
      if (body.scrollHeight - body.clientHeight > 4) {
        toggle.hidden = false;
      } else {
        toggle.hidden = true;
        body.classList.remove(CLAMPED);
      }
    }

    toggle.addEventListener('click', function () {
      if (open) {
        collapse();
      } else {
        expand();
      }
    });

    body.addEventListener('scroll', fade, { passive: true });

    toggle.textContent = more;
    toggle.setAttribute('aria-expanded', 'false');
    measure();

    var timer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (open) {
          collapse();
          expand();
        } else {
          measure();
        }
      }, 150);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }
  }

  function boot() {
    document.querySelectorAll('[data-av-clamp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
